export default __webpack_public_path__ + "static/media/phinestsSearch.cce73cc1.png";